module.exports = __webpack_public_path__ + "static/media/pouch.f183160f.svg";